import { IDropdownOption } from '../../../../shared/components/mat-dropdown/mat-dropdown.component';

export enum ECheckInDestinationType {
  workInstruction = 1,
  workInstructionStep = 2,
}

export interface ICheckInUser {
  id: number;
  name: string;
}

export interface ICheckIn {
  id: number;
  destinationTypeId: ECheckInDestinationType;
  destinationObjectId: number;
  sourceObjectId: number;
  checkInTime: string;
  checkOutTime: string | null;
  user?: ICheckInUser;
  /** Work instruction the check-in belongs to (directly, or through its step). */
  itemGuideAssignmentId: number;
  /** Step check-ins only (destination = the step's guide submission). */
  guideStepId: number | null;
  guideStepName: string | null;
}

export interface ICheckInDestination {
  typeId: ECheckInDestinationType;
  /** Work instruction → item guide assignment id; step → guide submission id. */
  objectId: number;
}

export interface ICheckInRequest {
  destination: ICheckInDestination;
  userId: number;
  /** Pre-translated message shown as a success toast once the API confirms the check-in. */
  successMessage?: string;
}

export interface ICheckOutRequest {
  checkInId: number;
  /** Pre-translated message shown as a success toast once the API confirms the check-out. */
  successMessage?: string;
}

export interface ICheckInBoardMembersRequest {
  boardId: number;
  search?: string;
}

export interface IWorkInstructionCheckInStep {
  guideSubmissionId: number;
  name: string;
}

export interface IWorkInstructionCheckInTarget {
  itemGuideAssignmentId: number;
  name: string;
  /** Steps that can be checked in to: started (they have a guide submission) and not completed. */
  steps?: IWorkInstructionCheckInStep[];
}

export interface IWorkInstructionCheckInDialogData {
  boardId: number;
  /** Item of the work instructions: when it is linked to an OEE Tracker line, that line's check-ins are offered too. */
  itemId?: number;
  /**
   * One entry → check-in dialog of that work instruction.
   * Several → "Check-ins" view: a work-instruction picker for check-in and the work instruction of every check-in.
   */
  workInstructions: IWorkInstructionCheckInTarget[];
  /** Pre-selected check-in destination, e.g. the stepper's current step. */
  initialDestination?: ICheckInDestination;
}

export interface IWorkInstructionCheckInRow {
  checkIn: ICheckIn;
  /** Time checked in so far (until the check-out for checked-out rows), e.g. "1d 4h 26m". */
  durationLabel: string;
  workInstructionName: string;
  /** "Step: <name>" for step check-ins; null for check-ins on the work instruction itself. */
  stepLabel: string | null;
}

/** Where the check-in user picker takes its users from. */
export enum ECheckInUserSource {
  oeeLine = 'oeeLine',
  boardMembers = 'boardMembers',
}

export interface IOeeLineCheckInUsers {
  /** Null when the item is not linked to an OEE Tracker line. */
  oeeLineId: number | null;
  /** Action Tracker users with an ongoing check-in on the line. */
  users: IDropdownOption[];
}

/** A pickable user of the check-in form. */
export interface ICheckInUserCard {
  id: number;
  name: string;
  isSelected: boolean;
}
